import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  viewBox: "0 0 56.336 64",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      transform: "matrix(.82677 0 0 .82677 4.5803 51.138)",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        d: "m39.1 15.557v-24.43l-21.16-12.22v24.43zm0-27.1-21.16-12.22v-24.44l21.16 12.22z",
        fill: "#5c4ee5"
      }),
      _createElementVNode("path", {
        d: "m62.6-23.773v-24.44l-21.17 12.22v24.44z",
        fill: "#4040b2"
      }),
      _createElementVNode("path", {
        d: "m15.62-25.193v-24.44l-21.16-12.22v24.44z",
        fill: "#5c4ee5"
      })
    ], -1)
  ]))]))
}
export default { render: render }